import { useLazyQuery } from "@apollo/client";
import { useDownloadJson } from "../../../../utilities/download-json";
import { QUERY_EXPORT_RAW_SALE_JSON } from "./constants";
import { ExportJsonFn } from "./types";

export const exportSaleJson = (): ExportJsonFn => {
  const { download } = useDownloadJson();

  const [q] = useLazyQuery(QUERY_EXPORT_RAW_SALE_JSON);

  const fn = async (saleId: string) => {
    return q({ variables: { saleId } })
      .then((res) => {
        return res.data.exportRawSaleJSON;
      })
      .then((json) => {
        return download({
          data: json,
          fileName: `retailer-sale-data-${saleId}.json`,
        });
      })
      .catch((err) => console.log(err));
  };

  return fn;
};
